<template>
  <v-container fluid fill-height>
    <v-layout row>
      <v-flex xs12 sm8 offset-sm2>
        <v-card>
          <v-toolbar color="light-blue" dark>
            <v-toolbar-title>My Projects</v-toolbar-title>
            <v-btn color="green" dark small absolute fab bottom right @click="addProjectDialog=true" title="New Project"><v-icon>add</v-icon></v-btn>
          </v-toolbar>
          <v-data-table :headers="myProjectsHeaders" :items="myProjects" :pagination.sync="pagination" class="elevation-5">
            <template slot="no-data"><tr><td colspan="100%" class="text-xs-center">Empty</td></tr></template>
            <template slot="items" slot-scope="props">
              <td>
                <v-text-field @change="updateProject(props.item)" v-on:keyup.enter="updateProject(props.item)" v-model="props.item.name" hide-details></v-text-field>
              </td>
              <td>
                <v-select @change="updateProject(props.item)" v-on:keyup.enter="updateProject(props.item)" :items="['Public', 'Private']" v-model="props.item.privacy" hide-details>
                  {{ props.item.privacy }}
                </v-select>
              </td>
              <td class="text-xs-left">
                <v-tooltip top>
                  <span slot="activator" class="text-xs-left">{{ formatDateRelative(props.item.updatedAt) }}</span>
                  <span>{{ formatDateAbsolute(props.item.updatedAt) }}</span>
                </v-tooltip>
              </td>
              <td class="text-xs-left">
                <v-tooltip top>
                  <span slot="activator" class="text-xs-left">{{ formatDateRelative(props.item.createdAt) }}</span>
                  <span>{{ formatDateAbsolute(props.item.createdAt) }}</span>
                </v-tooltip>
              </td>              
              <td class="layout">
                <v-btn icon class="mx-0" title="Open Project" @click="openProject(props.item)"><v-icon color="blue">open_in_browser</v-icon></v-btn>
                <v-btn icon class="mx-0" title="Duplicate Project" @click="duplicateProject(props.item)"><v-icon color="amber">file_copy</v-icon></v-btn>
                <v-btn icon class="mx-0" title="Delete Project" @click="deleteProject(props.item)"><v-icon color="pink">delete</v-icon></v-btn>
              </td>
            </template>
          </v-data-table>
          <v-layout row justify-center>
            <v-dialog v-model="addProjectDialog" persistent max-width="500px" :overlay="true">
              <v-card>
                <v-toolbar tabs><v-toolbar-title id="title">New Project</v-toolbar-title></v-toolbar>
                <div id="subheader">
                  <v-text-field prepend-icon="label" class="input-class-new" label="Name" v-model="newProject.name" type="text"></v-text-field>
                  <v-select prepend-icon="vpn_lock" class="input-class-new" label="Privacy Setting" v-model="newProject.privacy" :items="privacySettings"></v-select>
                </div>
                <v-toolbar tabs>
                  <v-spacer></v-spacer>
                  <v-btn color="info" @click="addProject">Add</v-btn>
                  <v-btn class="black--text" flat @click="addProjectDialog=false; newProject.name = ''; newProject.privacy = '';">Cancel</v-btn>
                </v-toolbar>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {EventBus} from '@/event-bus.js'
  import moment from 'moment'
  export default {
    data: () => ({
      addProjectDialog: false,
      myProjects: [],
      myProjectsHeaders: [
        {text: 'Name', value: 'name', align: 'left', sortable: false, width: '40%'},
        {text: 'Privacy', value: 'privacy', align: 'left', sortable: false, class: 'column-wrap'},
        {text: 'Modified', value: 'updatedAt', align: 'left', sortable: true},
        {text: 'Created', value: 'createdAt', align: 'left', sortable: true},
        {text: 'Actions', value: 'actions', align: 'left', sortable: false, class: 'column-wrap'}
      ],
      pagination: {
        'sortBy': 'updatedAt',
        'descending': true,
        'rowsPerPage': 10
      },
      privacySettings: ['Public', 'Private'],
      newProject: {
        name: '',
        privacy: '',
      }
    }),
    methods: {
      refreshProjects() {
        var ownerEmail = this.$store.state.email;
        EventBus.$emit('start-loading');
        this.$http.get(this.$store.state.serverHttpUrl+'/myprojects?ownerEmail='+ownerEmail).then(
          function(response) {
            this.myProjects = response.data;
            EventBus.$emit('stop-loading');
          }, function (err) {
            EventBus.$emit('stop-loading');
            EventBus.$emit('send-notification', {text: 'Error fetching projects ('+err+')'});
        });
      },
      addProject() {
        if(this.newProject.name==='' || this.newProject.privacy==='') return;
        var saveFileNew = new Array();
        this.$http.post(this.$store.state.serverHttpUrl+'/project', {
          name: this.newProject.name,
          ownerEmail: this.$store.state.email,
          ownerUsername: this.$store.state.user,
          privacy: this.newProject.privacy,
          saveFile: saveFileNew
        }).then(function (response) {
          EventBus.$emit('send-notification', {text: 'Project created successfully', color: 'success'});
          this.newProject.name = '';
          this.newProject.privacy = '';
          this.addProjectDialog = false;
          this.refreshProjects();
        }, function (err) {
          EventBus.$emit('send-notification', {text: 'Error creating project ('+err+')'});
        });
      },
      duplicateProject(item) {
        var copyNumber = 1;
        var projNames = this.myProjects.map(p => p.name);
        while(projNames.includes(item.name+'('+copyNumber+')'))
          copyNumber++;
        this.$http.post(this.$store.state.serverHttpUrl+'/project', {
          name: item.name + '(' + copyNumber + ')',
          ownerEmail: this.$store.state.email,
          ownerUsername: this.$store.state.user,
          privacy: item.privacy,
          saveFile: item.saveFile
        }).then(function (response) {
          EventBus.$emit('send-notification', {text: 'Project duplicated successfully', color: 'success'});
          this.refreshProjects();
        }, function (err) {
          EventBus.$emit('send-notification', {text: 'Error duplicating project ('+err+')'});
        })
      },
      openProject(item) {
        this.$store.dispatch('setCurrentProjectName', item.name);
        this.$store.dispatch('setCurrentProjectId', item._id);
        this.$router.push('/workspace');
      },
      updateProject(project) {
        this.$http.put(this.$store.state.serverHttpUrl+'/projectSettings', 
        {_id: project._id, ownerEmail: project.ownerEmail, ownerUsername: project.ownerUsername, name: project.name, privacy: project.privacy}).then(
          function (response) {
            EventBus.$emit('send-notification', {text: 'Project updated successfully', color: 'success'});
            this.refreshProjects();
          }, function (err) {
            EventBus.$emit('send-notification', {text: 'Error updating project ('+err+')'});
        });
      },
      deleteProject(item) {
        this.$swal({
          titleText: "Delete project \"" + item.name + "\"?",
          type: 'warning',
          showCancelButton: true,
          allowEnterKey: false,
          confirmButtonColor: '#FF5252',
          cancelButtonColor: '#33b5e5',
          confirmButtonText: 'Delete',
          customClass: 'elevation-5'
        }).then((result) => {
          if (result.value) {
            this.$http.delete(this.$store.state.serverHttpUrl+'/project?_id='+item._id+'&ownerEmail='+this.$store.state.email)
            .then(function (response) {
              EventBus.$emit('send-notification', {text: 'Project deleted successfully', color: 'success'});
              this.refreshProjects();
            }, function (err) {
              EventBus.$emit('send-notification', {text: 'Error deleting project ('+err+')'});
            })
          }
        });
      },
      formatDateRelative(date) {
        return moment(date).fromNow();
      },
      formatDateAbsolute(date) {
        return moment(date).format("dddd, MMMM Do YYYY, HH:mm:ss");
      },
    },
    created () {
      this.refreshProjects()
    }
  }
</script>

<style>
  table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0 10px
  }
  table.v-table thead th {
    background-color: #f2f2f2;
    color: #333333 !important;
    font-size: 13px;
    font-weight: bold;
    border-left: 1px dotted LightGray;
    border-right: 1px dotted LightGray;
    border-bottom: 1px solid LightGray;
  }
  table.v-table tbody td {
    word-wrap: break-word;
    font-size: 12px;
    font-weight: normal;
    border-left: 1px dotted LightGray;
    border-right: 1px dotted LightGray;
  }
  .v-input {
    font-size: 12px;
  }
  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
  }
  #header {
    margin: 5px;
    font-size: 30px;
    line-height: 1.5;
  }
  #subheader {
    margin: 20px;
    font-size: 20px;
    line-height: 1.5;
  }
  .input-class {
    margin-top: 10px;
    margin-bottom: 5px;
    margin-right: 10px;
    margin-left: 10px;
  }
  .input-class-new {
    width: 80%;
    position: relative;
    left: 10%;
  }
  .column-wrap {
    width: 1px;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyProjects/MyProjects.vue